import React, {useContext} from "react";
import classes from "./GoalItem.module.scss";
import colourClasses from "../../colour.module.scss";
import GoalContext from "../../store/goal-context";

//todo - add correct image src;

const GoalItem = (props) => {
    const goalContext = useContext(GoalContext);
    const colour = props.colour ? `colour--${props.colour}` : 'colour--black';
    const filterColour = props.colour ? `colour--${props.colour}--filtered` : 'colour--black--filtered'; 
    const activeState = goalContext.activeGoal === parseInt(props.goal) ? 'active-goal' : '';

    return (
        <li onClick={props.onClick} className={`${classes['goal-item']} ${colourClasses.colour} ${colourClasses[colour]} ${colourClasses[activeState]}`}>
            <div className={classes.offset} id={`goal-${props.goal}`}></div>
            <div className={classes['main-wrapper']}>
                <div className={`${classes['content-wrapper']} ${colourClasses['content-wrapper']}`}>
                    <div className={classes.number}>{props.id}</div>
                    <div className={classes.title}>{props.name}</div>
                </div>
                <div className={`${classes['image-wrapper']} ${colourClasses['image-wrapper']}`}>
                    <img src={props.primaryImage} alt={props.name} />
                </div>
            </div>
        </li>
    );
}


export default GoalItem